import { Room, Booking, Review } from '../types';

// Permanent Static Asset Paths
const doubleRoomMain = '/gallery/rooms/double_room.jpg';
const doubleRoomSlider1 = '/gallery/rooms/double_slide1.jpg';
const doubleRoomSlider2 = '/gallery/rooms/double_slide2.jpg';

const eightBedDormMain = '/gallery/rooms/eight_bed.jpg';
const eightBedDormsSlider1 = '/gallery/rooms/eight_slide1.jpg';
const eightBedDormsSlider2 = '/gallery/rooms/eight_slide2.jpg';

const sixBedDormMain = '/gallery/rooms/six_bed.jpg';
const sixBedDormsSlider1 = '/gallery/rooms/six_slide1.jpg';
const sixBedDormsSlider2 = '/gallery/rooms/six_slide2.jpg';

const womensFourDormMain = '/gallery/rooms/four_bed_womens.jpg';
const womensFourDormsSlider1 = '/gallery/rooms/four_slide1_womens.jpg';
const womensFourDormsSlider2 = '/gallery/rooms/four_slide2_womens.jpg';

const mensFourDormMain = '/gallery/rooms/four_bed_mens.jpg';
const mensFourDormsSlider1 = '/gallery/rooms/four_slide1_mens.jpg';
const mensFourDormsSlider2 = '/gallery/rooms/four_slide2_mens.jpg';

export const fallbackRooms: Room[] = [
  {
    id: 'double-room',
    name: 'Double room',
    description: 'Comfortable private room featuring one large bed, perfect for two guests. Includes free Wi-Fi, fresh linens, and modern amenities.',
    type: 'private',
    pricePerNight: 720,
    capacity: 2,
    availableBeds: 1,
    amenities: ['amWifi', 'amAc', 'amWater', 'amReception', 'amLuggage', 'amSecurity'],
    image: doubleRoomMain,
    images: [doubleRoomMain, doubleRoomSlider1, doubleRoomSlider2],
    rating: 4.95
  },
  {
    id: 'eight-bed-dorm',
    name: '8 Bed dorm',
    description: 'Budget friendly shared room featuring eight comfortable bunk beds. Includes free Wi-Fi, personal secure lockers, power outlets at each bed, and shared bathroom access.',
    type: 'dorm',
    pricePerNight: 290,
    capacity: 8,
    availableBeds: 6,
    amenities: ['amWifi', 'amLockers', 'amAc', 'amKitchen', 'amLaundry', 'amSecurity'],
    image: eightBedDormMain,
    images: [eightBedDormMain, eightBedDormsSlider1, eightBedDormsSlider2],
    rating: 4.82
  },
  {
    id: 'six-bed-dorm',
    name: '6 Bed dorm',
    description: 'Cozy shared room featuring six comfortable bunk beds. Includes free Wi-Fi, personal secure lockers, power outlets at each bed, and shared bathroom access.',
    type: 'dorm',
    pricePerNight: 310,
    capacity: 6,
    availableBeds: 4,
    amenities: ['amWifi', 'amLockers', 'amAc', 'amKitchen', 'amWater', 'amSecurity'],
    image: sixBedDormMain,
    images: [sixBedDormMain, sixBedDormsSlider1, sixBedDormsSlider2],
    rating: 4.88
  },
  {
    id: 'four-bed-womens-dorm',
    name: "4 Bed women's dorm",
    description: 'Cozy all female shared room featuring four comfortable bunk beds. Includes free Wi-Fi, personal secure lockers, power outlets, access to shared bathroom & kitchenette.',
    type: 'dorm',
    pricePerNight: 340,
    capacity: 4,
    availableBeds: 3,
    amenities: ['amWifi', 'amLockers', 'amAc', 'amKitchen', 'amLaundry', 'amSecurity'],
    image: womensFourDormMain,
    images: [
      womensFourDormMain,
      womensFourDormsSlider1,
      womensFourDormsSlider2
    ],
    rating: 4.96
  },
  {
    id: 'four-bed-mens-dorm',
    name: "4 Bed men's dorm",
    description: 'Comfortable shared room featuring four sturdy bunk beds, designed specifically for male travelers. Includes high-speed Wi-Fi, secure lockers, and individual power outlets.',
    type: 'dorm',
    pricePerNight: 340,
    capacity: 4,
    availableBeds: 2,
    amenities: ['amWifi', 'amLockers', 'amAc', 'amKitchen', 'amLaundry', 'amSecurity'],
    image: mensFourDormMain,
    images: [
      mensFourDormMain,
      mensFourDormsSlider1,
      mensFourDormsSlider2
    ],
    rating: 4.91
  }
];

export const fallbackBookings: Booking[] = [];

export const fallbackReviews: Review[] = [
  {
    id: 'REV-08',
    rating: 5,
    author: 'David Wouters',
    avatar: '/avatar-david.png',
    date: '2023-12-15',
    content: "It was like a fairytale staying in the beautiful Hotel Cozzydine. Thank you Chinju for being available 24/7 and for being such a good host. Would definitely stay here again in the future!",
    tags: ['Fairytale Vibe', '24/7 Availability', 'Outstanding Host', 'Beautiful Decor'],
    roomType: 'Double room'
  },
  {
    id: 'REV-03',
    rating: 5,
    author: 'Barry Vial',
    avatar: '/avatar-barry.png',
    date: '2024-05-10',
    content: "The host is very conscientious about keeping the place tidy and is very responsive.",
    tags: ['Conscientious Host', 'Always Tidy', 'Highly Responsive'],
    roomType: '6 Bed dorm'
  },
  {
    id: 'REV-06',
    rating: 5,
    author: 'Tony Pappa',
    avatar: '/avatar-tony.png',
    date: '2024-02-15',
    content: "Loved this place! Mostly because of the excellent location, wonderful view and perfect price for this city! It's not posh, but it's elegant and simple. I booked for two nights and stayed for two weeks. I did not want to leave my great room here, you'll feel the same if you like space, simple touches and great views. I can't recommend it highly enough.",
    tags: ['Extended Stay', 'Wonderful View', 'Elegant & Simple', 'Unbeatable Price'],
    roomType: 'Double room'
  },
  {
    id: 'REV-02',
    rating: 5,
    author: 'Віка Степанюк',
    avatar: '/avatar-vika.png',
    date: '2024-05-28',
    content: "Hostel is good for the price, everything is clean, beds are very comfortable. And the host is friendly and helpful. I recommend!",
    tags: ['Great Price', 'Super Clean', 'Comfortable Beds', 'Friendly Host'],
    roomType: "4 Bed women's dorm"
  },
  {
    id: 'REV-07',
    rating: 5,
    author: 'Tyson Edwards',
    avatar: '/avatar-tyson.png',
    date: '2024-01-30',
    content: "Hotel Cozzyden was the perfect place for us to calm down, unwind and relax after a stressful flight experience led to an unexpected one night stay in Kyiv. We had wonderful views over the city, building is charming, apartment was immaculate, plenty of space and the bathroom is particularly large and lovely. Our host Chinju was really great to us. Would absolutely return to Kyiv and stay here again.",
    tags: ['Perfect Sanctuary', 'Immaculate Apartment', 'Large Lovely Bathroom', 'Superb Views'],
    roomType: 'Double room'
  },
  {
    id: 'REV-04',
    rating: 5,
    author: 'Татьяна Руденко',
    avatar: '/avatar-tetyana.png',
    date: '2024-04-18',
    content: "Сподобалось комунікація зі мною як з не місцевою, постійно на звʼязку та пояснювали як добратися. В хостелі чисто та охайно, комфортне ліжко із чистою постіллю, є душ та кухня. Це підвальне приміщення а отже повітряна тривогу можна тут і перечекай.",
    tags: ['Чудова комунікація', 'Чисто і охайно', 'Безпечне укриття', 'Комфортне ліжко'],
    roomType: '8 Bed dorm'
  },
  {
    id: 'REV-01',
    rating: 5,
    author: 'Dieter van Rooyen',
    avatar: '/avatar-dieter.png',
    date: '2024-06-01',
    content: "Great location, right next to metro and ocean plaza shopping centre. Neat and tidy and the owner is always on site 24/7 if you have queries or issues(which you won't). If you're looking for affordable accommodation in the centre of Kyiv I'd highly recommend hostel cozzydine. I will definitely be staying here again during my time in Ukraine.",
    tags: ['Near Metro', 'Ocean Plaza', 'Affordable Centre', '24/7 Support'],
    roomType: '8 Bed dorm'
  },
  {
    id: 'REV-05',
    rating: 5,
    author: 'Tanja Bruns-Richter',
    avatar: '/avatar-tanja.png',
    date: '2024-03-22',
    content: "I have been here for the second time and it was a great pleasure to stay here again. Chinju is wonderful and professional host. I had some flight issues and arrived really late, but late check-in was no problem. It was really easy and flexible. The room was again very clean and well equipped with all the needful things. The view from the balcony is still outstanding. It’s super located, if you are interested in art and culture. Even the best techno (music) clubs are not far away. I highly recommend this place and would stay there anytime again.",
    tags: ['Repeat Guest', 'Professional Host', 'Outstanding Balcony View', 'Cultural Hub Location'],
    roomType: 'Double room'
  }
];

export const getCleanImage = (roomId: string, imgString: string | undefined, index?: number): string => {
  if (!imgString) return '/gallery/rooms/double_room.jpg';
  
  const trimmed = imgString.trim();

  // If it's already a clean local gallery path or base64 data, return it directly!
  if (trimmed.startsWith('/gallery/') || trimmed.startsWith('data:image')) {
    return trimmed;
  }

  // If we have an Unsplash URL, return it directly to preserve case sensitivity
  if (trimmed.includes('unsplash.com')) {
    return trimmed;
  }

  const cleanRoomId = (roomId || '').toLowerCase().trim();
  const f = fallbackRooms.find(item => item.id.toLowerCase() === cleanRoomId);
  
  if (!f) return trimmed;

  if (typeof index === 'number' && Array.isArray(f.images) && f.images[index]) {
    return f.images[index];
  }

  return f.image || trimmed;
};
